/* Do NOT modify this file  - Automatically generated */

window.algoliaShopify = {};
algoliaShopify.config = {
  app_id: 'B3R8YED9RG',
  search_api_key: '8aee76e0b34d9c80ba8873dec80fa3fd',
  index_prefix: 'shopify_test_',
  index_products: true,
  index_collections: true,
  index_articles: false,
  index_pages: true,
  sort_orders: [{
    key: 'recently_ordered_count',
    title: 'Popularity',
    desc: { active: true, title: 'Most popular' }
  }, {
    key: 'price',
    title: 'Price',
    desc: { active: true, title: 'Most expensive first' }
  }, {
    key: 'price',
    title: 'Price',
    asc: { active: true, title: 'Cheapest first' }
  }, {
    key: 'price_ratio',
    title: 'Price ratio',
    asc: { active: false, title: 'Highest discount first' }
  }, {
    key: 'published_at',
    title: 'Publication date',
    asc: { active: false, title: 'Oldest first' }
  }, {
    key: 'published_at',
    title: 'Publication date',
    desc: { active: false, title: 'Newest first' }
  }, { key: 'vendor', title: 'Vendor', asc: { active: false, title: 'Vendor' } }, {
    key: 'vendor',
    title: 'Vendor',
    desc: { active: false, title: 'Vendor Z-A' }
  }, {
    key: 'inventory_quantity',
    title: 'Inventory quantity',
    desc: { active: false, title: 'Most available' }
  }, {
    key: 'grams',
    title: 'Weight',
    asc: { active: false, title: 'Lightest first' }
  }, {
    key: 'grams',
    title: 'Weight',
    desc: { active: false, title: 'Heaviest first' }
  }, { key: 'title', title: 'Name', asc: { active: false, title: 'Name' } }, { key: 'title', title: 'Name', desc: { active: false, title: 'Name Z-A' } }],
  facets: [{
    available_types: ['slider'],
    enabled: true,
    name: 'price',
    title: 'Price',
    type: 'slider'
  }, {
    available_types: ['conjunctive', 'disjunctive', 'slider'],
    enabled: true,
    forgettable: true,
    name: 'options.color',
    title: 'Color',
    type: 'conjunctive'
  }, {
    available_types: ['conjunctive', 'disjunctive', 'slider'],
    enabled: true,
    forgettable: true,
    name: 'options.size',
    title: 'Size',
    type: 'conjunctive'
  }, {
    available_types: ['menu', 'conjunctive', 'disjunctive'],
    enabled: true,
    name: 'product_type',
    title: 'Type',
    type: 'conjunctive'
  }, {
    available_types: ['menu', 'conjunctive', 'disjunctive'],
    enabled: false,
    name: 'vendor',
    title: 'Vendor',
    type: 'conjunctive'
  }, {
    available_types: ['disjunctive'],
    enabled: false,
    name: 'price_range',
    title: 'Price range',
    type: 'disjunctive'
  }, {
    available_types: ['menu', 'conjunctive', 'disjunctive'],
    enabled: false,
    name: 'tags',
    title: 'Tags',
    type: 'conjunctive'
  }],
  powered_by: false,
  colors: { main: '#e83a9f', secondary: '#54565b', highlight: '#e83a9f' },
  autocomplete_enabled: true,
  autocomplete_debug: false,
  input_selector: 'form[action="/search"] input[type="text"], form[action="/search"] input[type="search"]',
  products_autocomplete_hits_per_page: 6,
  collections_autocomplete_hits_per_page: 3,
  articles_autocomplete_hits_per_page: 3,
  pages_autocomplete_hits_per_page: 2,
  instant_search_enabled: true,
  results_selector: 'main > .wrapper',
  products_full_results_hits_per_page: 24,
  collections_full_results_hits_per_page: 10,
  show_products: false
};